import { Badge } from "@/components/ui/badge";
import type { ReviewSummary } from "@/interfaces/review";
import { cn } from "@/lib/utils";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { useState, type Dispatch, type SetStateAction } from "react";

type ReviewFilter = "all" | "positive" | "negative";

interface Props {
  summary?: ReviewSummary;
  isActive: ReviewFilter;
  setIsActive: Dispatch<SetStateAction<ReviewFilter>>;
}

export default function ReviewFilters({
  summary,
  isActive,
  setIsActive,
}: Props) {
  return (
    <div className="space-y-4">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <Badge
            onClick={() => setIsActive("all")}
            className={cn(
              "flex-1 cursor-pointer px-4 py-2 transition-colors duration-200 justify-center",
              isActive === "all"
                ? "bg-primary text-primary-foreground"
                : "bg-transparent border border-border text-muted-foreground hover:bg-secondary",
            )}
          >
            All ({summary?.totalReviews ?? 0})
          </Badge>
          <Badge
            onClick={() => setIsActive("positive")}
            className={cn(
              "flex-1 cursor-pointer px-4 py-2 justify-center transition-colors",
              isActive === "positive"
                ? "bg-emerald-500 text-white hover:bg-emerald-600"
                : "bg-transparent border border-border text-foreground hover:bg-secondary",
            )}
          >
            <span
              className={cn(
                "mr-2 flex items-center",
                isActive === "positive" ? "text-white" : "!text-emerald-500",
              )}
            >
              <ThumbsUp size={16} strokeWidth={2.5} />
            </span>
            Positive ({summary?.positiveReviews ?? 0})
          </Badge>

          <Badge
            onClick={() => setIsActive("negative")}
            className={cn(
              "flex-1 cursor-pointer px-4 py-2 justify-center transition-colors",
              isActive === "negative"
                ? "bg-red-500 text-white hover:bg-red-600"
                : "bg-transparent border border-border text-foreground hover:bg-secondary",
            )}
          >
            <span
              className={cn(
                "mr-2 flex items-center",
                isActive === "negative" ? "text-white" : "!text-red-500",
              )}
            >
              <ThumbsDown size={16} strokeWidth={2.5} />
            </span>
            Negative ({summary?.negativeReviews ?? 0})
          </Badge>
        </div>
      </div>
    </div>
  );
}
